import SecurityIcon from "@mui/icons-material/Security";

export const RoleIcon = SecurityIcon;

